import { FCC, ReactComponentsThemeProvider, getTheme, useBrandTheme } from "@dgs/core";
import { config } from "./config/config";
import { useFrontendConfig } from "./config/useFrontendConfig";

export const JarvisThemeProvider: FCC = ({ children }) => {
	const { brand, apiUrl } = useFrontendConfig();
	const theme = getTheme(config.mode);
	const brandTheme = useBrandTheme(config.themeName, theme, brand, apiUrl);

	return <ReactComponentsThemeProvider theme={brandTheme}>{children}</ReactComponentsThemeProvider>;
};
